import type { TaskStatus } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface TaskResponse {
  id: string
  title: string
  description: string
  status: TaskStatus
  createdAt: string
  updatedAt: string
}

// Fetch all tasks
export const fetchTasks = async () => {
  const response = await gozokiApiWithAuth.get<TaskResponse[]>('/real-estate-tasks')
  return response.data
}
